exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".breadcrumb-wrap{width:100%;height:50px;line-height:50px;background:#fff;border-bottom:1px solid #e5e5e5;padding-left:20px}.breadcrumb-wrap .breadcrumb{padding:0;margin-bottom:0;background:transparent;cursor:default}.breadcrumb-wrap .breadcrumb .nolink a{color:#666}.breadcrumb-wrap .breadcrumb a{text-decoration:none}.breadcrumb-wrap .breadcrumb>li+li:before{content:\">\";color:#323232}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./src/common/components/common/bread-crumb/bread-crumb.scss
// module id = 580
// module chunks = 2